export class Specialist {
  id: string;
  available: boolean;
  curriculum: string;
  name: string;
  email: string;
  phoneNumber: string;
  specialty: string;
  imageUrl?: string | null;
  dateDuration?: number | null;
  datePrice?: number | null;
  diary?: { [key: string]: DiaryEntry[] } | null;
  app?: string | null;
}

interface DiaryEntry {
  start: string;
  end: string;
}

export enum WeekDays {
  'monday' = 'Lunes',
  'tuesday' = 'Martes',
  'wednesday' = 'Miércoles',
  'thursday' = 'Jueves',
  'friday' = 'Viernes',
  'saturday' = 'Sábado',
  'sunday' = 'Domingo',
}
